import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Offcanvas, Nav, Accordion } from 'react-bootstrap'
import useAuth from '../../context/auth/useAuth'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getSchool } from '../../actions/schoolsActions'
import { getScheduledInterviewsQuantityBySchool } from '../../actions/choosesActions'
import SchoolCalendar from '../calendars/SchoolCalendar'

export const HeaderSchool = () => {
    const { t } = useTranslation()
	const {client, logout} = useAuth()
    const dispatch = useDispatch()
    const location = useLocation()

    const {school} = useSelector(state=>state.schools)

    const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)
    const [showCalendar, setShowCalendar] = useState(false)
    const {scheduleQty} = useSelector(state => state.chooses)

    const isactiveProcessesActive = (path) => {
		let isActive = false

		if (location.pathname === '/school/activeprocesses') {
			isActive = true
		}

		if (/^\/school\/overviewprocess\/[a-zA-Z0-9]+\/candidates$/.test(path)) {
			isActive = true
		}

		if (/^\/school\/overviewprocess\/[a-zA-Z0-9]+\/precandidates$/.test(path)) {
			isActive = true
		}

		return isActive
	}

    useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
        }
    },[dispatch, t, client])
    
    useEffect(() => {
        if(school){
            dispatch(getScheduledInterviewsQuantityBySchool(school._id))
        }
    },[school, dispatch])

    return (
        <header>
            <Container>
                <Row className='my-1 d-flex justify-content-between'>
                    <Col className='d-flex align-items-center'>
                        <Button variant="primary" onClick={handleShow} className='d-block d-sm-none'>
                            icono
                        </Button>
                        <Link to="/school/dashboard">
                            <img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
                        </Link>
                    </Col>
                    <Col className='d-flex justify-content-end align-items-center'>
                        <a className='ms-3 cursor alert-container' onClick={() => setShowCalendar(true)}>
                            <img src="/images/menus/calendar.svg" alt="Icono Calendario" />
                            {scheduleQty > 0 && <span className='alert-badge'></span>}
                        </a>
                        <div  className='d-block d-lg-none ms-3'>
                            <i className='fa fa-bars cursor color-primary' onClick={handleShow}></i>
                        </div>                      
                    </Col>
                </Row>
            </Container>
            <Offcanvas show={show} onHide={handleClose}>
				<Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <Link to="/school/dashboard" onClick={handleClose}>
                            <img src='/images/logotipo.svg' alt="Logotipo Skill Connected" />
                        </Link>
                    </Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body className='menu-lateral'>
                    <Nav className="flex-column">
						<Nav.Item>
							<Link to="/school/dashboard" className={`nav-link ${location.pathname === '/school/dashboard' ? 'active' : ''}`}>
								<img src="/images/menus/home.svg" alt="Icono Mi Perfil" className='me-3'/>
								{t('menus.home')}
							</Link>
						</Nav.Item>
						<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" className="ps-1">
									<Accordion.Header>
										<img src="/images/menus/user.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.school')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav className="flex-column">
											<Nav.Item>
												<Link to="/school/profile" className={`nav-link ${location.pathname === '/school/profile' ? 'active' : ''}`}>
													{t('menus.profile')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/school/staff" className={`nav-link ${location.pathname === '/school/staff' ? 'active' : ''}`}>
													{t('menus.staff')}
												</Link>
											</Nav.Item>
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						<Nav.Item>
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" className="ps-1">
									<Accordion.Header>
										<img src="/images/config.svg" alt="Icono Mi Perfil" className='me-3'/>
										{t('menus.processes')}
									</Accordion.Header>
									<Accordion.Body>
										<Nav defaultActiveKey="/config" className="flex-column">
											{/* <Nav.Item>
												<Link to="/school/startprocess" className={`nav-link ${location.pathname === '/school/startprocess' ? 'active' : ''}`}>
													{t('menus.startprocess')}
												</Link>
											</Nav.Item> */}
											<Nav.Item>
												<Link to="/school/programprocess" className={`nav-link ${location.pathname === '/school/programprocess' ? 'active' : ''}`}>
													{t('menus.programprocess')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/school/activeprocesses" className={`nav-link ${isactiveProcessesActive(location.pathname) ? 'active' : ''}`}>
													{t('menus.activeprocesses')}
												</Link>
											</Nav.Item>
											<Nav.Item>
												<Link to="/school/completedprocesses" className={`nav-link ${location.pathname === '/school/completedprocesses' ? 'active' : ''}`}>
													{t('menus.completedprocesses')}
												</Link>
											</Nav.Item>
										</Nav>
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</Nav.Item>
						<Nav.Item>
							<Link to="/school/database/favourites" className='nav-link'>
								<img src="/images/menus/database.svg" alt="Data base" className='me-3'/>
								{t('menus.database')}
							</Link>
						</Nav.Item>
						<Nav.Item>
							<Link to="/school/tickets" className='nav-link'>
								<img src="/images/menus/ticket.svg" alt="Tickets" className='me-3'/>
								{t('menus.tickets')}
							</Link>
						</Nav.Item>
					</Nav>
				</Offcanvas.Body>
			</Offcanvas>
            <SchoolCalendar visible={showCalendar} setVisible={setShowCalendar}/>
        </header>
    )
}
